<template>
  <div>
    <div class="container">
      <div class="nav">
        <div class="right">
          <img src="../assets/img/MyDrive.svg" alt="">
          <span>Cloud Storage</span>
        </div>
        <span>Storage space : 15GB (Limit : 17GB)</span>
        </div>
      <div class="sideNavs">
        <a :href="item.id" class="sideNav" v-for="item in users" :key="item.id">
          <img :src="item.img" alt="">
          <span> {{ item.name }} </span>
        </a>
      <div id="search">
        <div class="searchWindow">
          <div class="top">
            <a href="#!">
              <span></span>
            </a>
            <span>Search your files</span>
          </div>
          <div class="bottom">
            <div class="bottom_inner">
              <input type="text" placeholder="Spring your files">
                <img src="../assets/img/Search.svg" alt="">
            </div>
          </div>
        </div>
        </div>
      </div>
      <div class="upLoadFile">
        <div class="top">
          <span></span>
          <span>Upload new file</span>
        </div>
        <div id="close">
        <div class="bottom">
          <img src="../assets/img/Upload.svg" alt="">
          <span class="drop">Drop files here Or</span>
          <label class="link">
            <input id="link" type="file">
            <span>Browse</span>
          </label>
        </div>
        </div>
      </div>
      <div class="rightFiles">
        <div class="rightFile" v-for="item in files" :key="item.id">
          <img :src="item.img" alt="">
          <span> {{ item.name }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [
        {
          name: 'Search',
          img: require('../assets/img/Search.svg'),
          id: '#search'
        },
        {
          name: 'My Drive',
          img: require('../assets/img/MyDrive.svg'),
          id: '#drive'
        },
        {
          name: 'Sharing',
          img: require('../assets/img/Sharing.svg'),
          id: '#sharing'
        },
        {
          name: 'Delete',
          img: require('../assets/img/Deleted.svg'),
          id: '#delete'
        },
      ],
      files: [
        {
          name: 'Sparing Projects',
          img: require('../assets/img/Folder.svg')
        },
        {
          name: 'Design Projects',
          img: require('../assets/img/Folder.svg')
        },
        {
          name: 'Frontend Projects',
          img: require('../assets/img/Folder.svg')
        },
        {
          name: 'Backend Projects',
          img: require('../assets/img/Folder.svg')
        },
        {
          name: 'Music files',
          img: require('../assets/img/Folder.svg')
        },
        {
          name: 'Photograph',
          img: require('../assets/img/File.svg')
        },
        {
          name: 'Memory',
          img: require('../assets/img/Folder.svg')
        },
        {
          name: 'Article',
          img: require('../assets/img/File.svg')
        },
        {
          name: 'Resource',
          img: require('../assets/img/Folder.svg')
        },
      ]
    }
  }
}
</script>


<style scoped lang="sass">
@mixin setBgImg($img,$w,$h,$bgs,$bgp)
  background-image: url(../img/#{$img})
  width: $w
  height: $h
  background-size: $bgs
  background-position: $bgp
@mixin setFlex($j,$a)
  display: flex
  justify-content: $j
  align-items: $a
a
  text-decoration: none
  color: #000
.container
  padding: 0
  margin: -10px
  +setBgImg('../assets/img/Background.svg',null,null,cover,100% 100%)
.nav
  border: 4px solid #000
  background-color: #FCF6E7
  +setFlex(space-between,center)
  padding: 7px 20px
  box-sizing: border-box
  margin-bottom: 40px
  img
    margin-right: 11px
    width: 20px
    height: 20px
  span
    font-weight: bold
    font-style: italic
    font-size: 12px
.sideNavs
  width: 125px
  border: 4px solid #000
  border-bottom: none
  padding: 20px 25px
  box-sizing: border-box
  background-color: #FCF6E7
  .sideNav
    +setFlex(center,center)
    flex-direction: column
    margin-bottom: 27px
    cursor: pointer
  #search:target .searchWindow
    opacity: 1
    visibility: visible
  .searchWindow
    position: fixed
    top: 20%
    left: 50%
    max-width: 500px
    width: 100%
    background-color: #FCF6E7
    border: 4px solid #000
    transform: translateX(-50%)
    transition: .3s
    opacity: 0
    visibility: hidden
    .top
      text-align: center
      +setFlex(space-between,center)
      border-bottom: 4px solid #000
      a
        width: 40px
        height: 40px
        position: relative
        background-color: #FDE8B4
        border-right: 4px solid #000
        span
          position: absolute
          width: 100%
          height: 100%
          top: 50%
          left: 50%
          transform: translate(-50%,-50%)
          &::after,&::before
            content: ''
            position: absolute
            top: 32%
            left: 50%
            transform: translate(-50%,-50%)
            height: 16px
            width: 3px
            background-color: black
          &::after
            transform: rotate(45deg)
          &::before
            transform: rotate(-45deg)
      span
        flex: 8
        letter-spacing: 1px
        font-weight: bold
    .bottom
      .bottom_inner
        margin: 13px 17px
        border: 4px solid #000
        background-color: #FDE8B4
        +setFlex(space-between,center)
        input
          flex: 8
          background-color: transparent
          border: none
          outline: none
          font-size: 16px
          padding: 18px 0px
          box-sizing: border-box
          border-right: 4px solid #000
          text-align: center
        img
          flex: 1
          margin: 0px 4px
          cursor: pointer

.upLoadFile
  width: 250px
  background-color: #FCF6E7
  border: 4px solid #000
  .top
    text-align: center
    +setFlex(space-between,center)
    border-bottom: 4px solid #000
    span
      position: relative
      padding: 8px 0px
      box-sizing: border-box
      cursor: pointer
      &:nth-child(1)
        flex: 2
        background-color: #FDE8B4
        height: 38px
        &::after
          content: ''
          position: absolute
          left: 50%
          top: 50%
          transform: translate(-50%,-50%)
          width: 16px
          height: 3px
          background-color: black
      &:nth-child(2)
        flex: 8
        border-left: 4px solid #000
  .bottom
    +setFlex(center,center)
    flex-direction: column
    text-align: center
    padding: 40px 0px 30px 0px
    img
      margin-bottom: 20px
    .drop
      color: #666666
      max-width: 90px
      width: 100%
      font-size: 12px
      margin-bottom: 15px
    .link
      font-size: 16px
      border-bottom: 1px solid #000
      position: relative
      cursor: pointer
      width: 90px
      input
        opacity: 0
      span
        position: absolute
        left: 50%
        top: 50%
        transform: translate(-50%,-50%)

.rightFiles
  position: absolute
  right: 30px
  top: 90px
  +setFlex(center,center)
  flex-direction: column
  flex-wrap: wrap-reverse
  max-height: 750px
  img
    margin-bottom: 10px
  .rightFile
    +setFlex(flex-start,center)
    flex-direction: column
    margin-bottom: 20px
    cursor: pointer
    letter-spacing: 1px
    font-weight: bold
    padding: 12px
    position: relative
    z-index: 1
    height: 118px
    &:hover
      &::after
        position: absolute
        content: ''
        top: 0
        background-color: #FDE8B4
        border: 4px solid #000
        box-sizing: border-box
        width: 100%
        height: 100%
        z-index: -1
    span
      max-width: 100px
      width: 100%
      text-overflow: ellipsis
      text-align: center
</style>
